import {LOCALE_ALIASES} from "./locale-data.ts";

/**
 * Given 'en-US-southern', yield 'en-US-southern', 'en-US', 'en'.
 *
 * Locales are composed of 1 to 4 parts, the language, an optional
 * script, an optional territory, and an optional variant in that order. For
 * example we might have inputs of 'zh-Hant-CN' which is lang-script-territory
 * or we may have just 'zh-CN' which is lang-territory, 'zh-Hant' which is
 * lang-script, or just 'zh'.
 *
 * For babel the seperator is _ though we use - in our urls to match crowdin.
 * We accept either separator as input, but we normalize all output to use -.
 * Places that pass on the results to babel will need to munge it to use _.
 *
 * We also *extend* language-tags if babel thinks there is a default
 * extension.  That is, given 'pt', yield 'pt', 'pt-BR'.  This way,
 * if a user specifies 'pt' but we only have info for 'pt-BR', we
 * can still return it.
 *
 * @param {string} locale
 * @return {Array<string>}
 */
export const getLocalePrefixes = (locale: string): Array<string> => {
    // sync-start:locale-prefixes 512843902 https://github.com/Khan/webapp/blob/master/services/content-library/rssfeeds/locale_util.go
    const prefixes = locale.split(/[-_]/).map((element, index, array) => {
        return array.slice(0, array.length - index).join("-");
    });
    if (locale in LOCALE_ALIASES) {
        prefixes.push(LOCALE_ALIASES[locale]);
    }
    return prefixes;
    // sync-end:locale-prefixes
};
